export default __webpack_public_path__ + "c331f6b1e90abe61f954572b15cf82d3.png";